import { render } from "./Main.vue?vue&type=template&id=b0411656&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=b0411656&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b0411656"

export default script